export default {"src":"/_next/static/media/default-medal.5d6db918.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};